












































































import { defineComponent, ref } from '@vue/composition-api';
import { verificaEmail } from '@/useable/verification';
import { Message } from 'element-ui';
import svgCom from '@components/Svg/index';
import PwdInput from '@components/PwdInput/index';
import md5 from 'js-md5';
import request from '@utils/request';

export default defineComponent({
  name: 'Reset',
  components: {
    svgCom,
    PwdInput,
  },
  setup(prop, { root }) {
    const email = ref('');
    const { step, workEmail, code } = root.$route.query;
    console.log(step);
    
    const password = ref('');
    const confirmPassword = ref('');

    const activeSteps = step ? ref(Number(step)) : ref(1);
    const sendEmail = async () => {
      if (verificaEmail(email.value)) {
        const res = await request('login', 'sendMail', {
          sendMsgList: [{
            workEmail: email.value
          }],
          type: 'pas'
        });
        
        if (res.code === 2000) {
          Message.success('邮件发送成功！');
          activeSteps.value = 2;
        }
      } else {
        Message.error('请输入正确的邮箱');
      }
    };

    const toLogin = async () => {
      const res = await request('login', 'resetPassword', {
        password: md5(password.value),
        confirmPassword: md5(confirmPassword.value),
        workEmail,
        code
      });

      if (res.code === 2000) {
        Message.success('密码重置成功！');
        root.$router.push({
          name: 'Login',
        });
      } else {
        
      }
    };
    
    return {
      activeSteps,
      email,
      sendEmail,
      toLogin,
      password,
      confirmPassword,
    };
  },
});
